import { useForm } from 'react-final-form'
import { format } from 'date-fns'
import { TerminalItem, TerminalScheduleItem } from 'schema'
import { devFeatures } from 'utils/feature'

import { useActions } from './useActions'

export const useMockOrderCreate = () => {
  const form = useForm()
  const { setFullInfo } = useActions()
  const setMockData = () => {
    form.change('customer', {
      type: 'individual'
    })
    form.change('isAgreeOffer', true)
    form.change('cargo', [
      {
        type: 'custom',
        amount: 1,
        about: '2',
        customLength: 2,
        customWidth: 2,
        customHeight: 2,
        customWeight: 2,
        price: 2
      }
    ])
    form.change('cargoTotal', {
      type: 'custom'
    })
    form.change('cargoType', 'separate')
    form.change('comment', '')
    form.change('creator', {
      document: {
        type: 'passportRF',
        series: '3213',
        number: '321312'
      },
      lastname: 'Максимов',
      firstname: 'Владимир',
      secondname: 'Денисович',
      phone: '79226368888'
    })
    form.change('customer', {
      type: 'individual'
    })
    form.change('departureDate', format(new Date(), 'yyyy-MM-dd'))

    form.change('departurePartner', {
      contact: {
        firstname: 'Владимир',
        lastname: 'Максимов',
        secondname: 'Денисович',
        phone: '79226368888'
      },
      isUser: 'yes',
      type: 'individual'
    })
    form.change('departurePoint', {
      terminalId: '71a7f62c-1226-11de-9753-00238b172984',
      isCourier: false
    })
    form.change('destinationPartner', {
      contact: {
        firstname: 'Владимир',
        lastname: 'Максимов',
        secondname: 'Денисович',
        phone: '79226368888'
      },
      isUser: 'yes',
      type: 'individual'
    })
    form.change('destinationPoint', {
      terminalId: '3b8fd273-915c-11e2-91a6-001b24936c9e',
      isCourier: true,
      addressDetail: {
        address: 'г Томск, пр-кт Мира, д 20',
        latitude: '56.508648',
        longitude: '84.966675',
        fiasId: 'e3b0eae8-a4ce-4779-ae04-5c0797de66be'
      }
    })
    form.change('payer', {
      role: 'customer'
    })

    setFullInfo({
      fromPoint: {
        // @ts-ignore
        selectedOption: {
          value: 'г Екатеринбург',
          fullAddress: '620000, Свердловская обл, г Екатеринбург',
          latitude: '56.838607',
          longitude: '60.605514',
          fiasLevel: '4',
          fiasId: '2763c110-cb8b-416a-9dac-ad28a55b4402'
        },
        daDataSearchAddressValue: 'trf',
        isAddressCourierDelivery: true,
        isAddressTerminalDelivery: true,
        terminals: [
          {
            id: '71a7f62c-1226-11de-9753-00238b172984',
            name: 'QP5 Екатеринбург',
            type: TerminalItem.type.TERMINAL,
            address: 'г Екатеринбург, ул Вишневая, д 2Д',
            phones: ['78002504099'],
            emails: ['support@qp5-express.ru'],
            unpaidDays: 3,
            latitude: '56.834885',
            longitude: '60.636452',
            schedule: [
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
                from: '15:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
                from: '07:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
                from: '07:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
                from: '07:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
                from: '07:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.SAT,
                from: '07:00',
                to: '15:00'
              }
            ],
            // @ts-ignore
            isDeparture: true,
            isDestination: true
          },
          {
            id: 'd5a6054b-0a3d-11e7-80e4-005056a953b9',
            name: 'РЦ Верхняя Пышма',
            type: TerminalItem.type.TERMINAL,
            address: 'Свердловская обл, г Верхняя Пышма, поселок Залесье, Индустриальный проезд, зд 1 к 2',
            phones: ['78002504099'],
            emails: ['support@qp5-express.ru'],
            unpaidDays: 3,
            latitude: '56.964367',
            longitude: '60.664785',
            schedule: [
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.SAT,
                from: '07:00',
                to: '21:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.SUN,
                from: '07:00',
                to: '21:00'
              }
            ],
            // @ts-ignore
            isDeparture: true,
            isDestination: true
          }
        ],
        selectedTerminal: {
          id: '71a7f62c-1226-11de-9753-00238b172984',
          name: 'QP5 Екатеринбург',
          address: 'г Екатеринбург, ул Вишневая, д 2Д',
          phones: ['78002504099'],
          type: TerminalItem.type.TERMINAL,
          emails: ['support@qp5-express.ru'],
          unpaidDays: 3,
          latitude: '56.834885',
          longitude: '60.636452',
          schedule: [
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
              from: '15:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
              from: '07:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
              from: '07:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
              from: '07:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
              from: '07:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.SAT,
              from: '07:00',
              to: '15:00'
            }
          ],
          // @ts-ignore
          isDeparture: true,
          isDestination: true
        },
        comment: '',
        errorAddress: '',
        isCourier: false
      },
      toPoint: {
        // @ts-ignore
        selectedOption: {
          value: 'г Томск, пр-кт Мира, д 20',
          fullAddress: '634057, Томская обл, г Томск, пр-кт Мира, д 20',
          latitude: '56.508648',
          longitude: '84.966675',
          fiasLevel: '8',
          fiasId: 'e3b0eae8-a4ce-4779-ae04-5c0797de66be'
        },
        daDataSearchAddressValue: 'njvcr vbhf 20',
        isAddressCourierDelivery: true,
        isAddressTerminalDelivery: true,
        terminals: [
          {
            id: '3b8fd273-915c-11e2-91a6-001b24936c9e',
            name: 'QP5 Томск',
            address: 'г Томск, ул Пушкина, д 65/2',
            phones: ['78002504099'],
            type: TerminalItem.type.TERMINAL,
            emails: ['support@qp5-express.ru'],
            unpaidDays: 3,
            latitude: '56.499066',
            longitude: '84.991163',
            schedule: [
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
                from: '08:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
                from: '08:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
                from: '08:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
                from: '08:00',
                to: '22:00'
              },
              {
                dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
                from: '08:00',
                to: '22:00'
              }
            ],
            // @ts-ignore
            isDeparture: true,
            isDestination: true
          }
        ],
        selectedTerminal: {
          id: '3b8fd273-915c-11e2-91a6-001b24936c9e',
          name: 'QP5 Томск',
          address: 'г Томск, ул Пушкина, д 65/2',
          phones: ['78002504099'],
          type: TerminalItem.type.TERMINAL,
          emails: ['support@qp5-express.ru'],
          unpaidDays: 3,
          latitude: '56.499066',
          longitude: '84.991163',
          schedule: [
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
              from: '08:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
              from: '08:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
              from: '08:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
              from: '08:00',
              to: '22:00'
            },
            {
              dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
              from: '08:00',
              to: '22:00'
            }
          ],
          // @ts-ignore
          isDeparture: true,
          isDestination: true
        },
        comment: '',
        errorAddress: '',
        isCourier: true
      },
      isDadataDisable: false,
      customerId: ''
    })
  }

  // TODO тут проверять что это local|stand - на проде false
  return { setMockData, isCanMock: devFeatures }
}
